import * as React from 'react';

/** Measures an element's width with a rAF-throttled ResizeObserver. */
export function useChartSize(fallbackWidth = 320): {
  ref: React.RefObject<HTMLDivElement | null>;
  width: number;
} {
  const ref = React.useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = React.useState(0);

  React.useEffect(() => {
    const element = ref.current;
    if (!element || typeof ResizeObserver === 'undefined') return;

    let frame = 0;
    const observer = new ResizeObserver(entries => {
      const next = entries[0]?.contentRect.width ?? 0;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setWidth(next));
    });

    observer.observe(element);
    setWidth(element.getBoundingClientRect().width);

    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
    };
  }, []);

  return { ref, width: width > 0 ? width : fallbackWidth };
}
